import { useQuery } from "@tanstack/react-query";
import apiClient from "@/services/api/client";
import { API_ENDPOINTS } from "@/services/api/endpoints";

export interface PortalRole {
  id: string;
  name: string;
  description?: string | null;
  is_active: boolean;
}

interface RolesResponse {
  roles: PortalRole[];
  total: number;
}

export const usePortalRoles = (portalId: string) => {
  const query = useQuery({
    queryKey: ["portal-roles", portalId],
    queryFn: async () => {
      const response = await apiClient.get<RolesResponse>(
        API_ENDPOINTS.SYSTEM.PORTAL_ROLES.LIST(portalId),
      );
      return response.data.roles;
    },
    enabled: !!portalId,
    staleTime: 5 * 60 * 1000,
  });

  return {
    roles: query.data ?? [],
    isLoading: query.isLoading,
  };
};
